import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { IconButton, styled } from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";

const StyledButton = styled(IconButton)(() => ({
  borderRadius: "30px",
}));
const StyledDay = styled(PickersDay)(() => ({
  borderRadius: "30px",
  fontSize: "13px",
}));
// const StyledTextField = styled(TextField)(() => ({
//   variant: "filled",
//   color: "#c4960c",
//   size: "small",
// }));

export default function Calendar({ title, value, handleChange, disabled }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en-gb"}>
      <DemoContainer components={["DatePicker"]}
        sx={{
          "&.MuiStack-root": {
            paddingTop: "10px",
            marginTop: "-10px",
            overflow: "visible",
          },
        }}>
        <DatePicker views={["day", "month", "year"]} label={title} value={dayjs(value)} onChange={handleChange} disabled={disabled}
          sx={{
            maxWidth: true,
            "& label.Mui-focused": {
              color: "#c4960c",
            },
            "& .MuiOutlinedInput-root": {
              // fontSize: "13px",
              "&.Mui-focused fieldset": {
                borderColor: "#c4960c",
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: "14px",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
            "& .MuiPickersDay-root": {
              "&.Mui-selected": {
                backgroundColor: "#c4960c",
              },
              fontSize: "13px",
              borderRadius: "30px",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
            "& .css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input": {
              fontSize: "13px",
              height: "12px",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
            "& .MuiInputBase-root": {
              fontSize: "13px",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
            "&.MuiTextField-root": {
              width: "100%",
              minWidth: "50px",
            },
          }}
          slots={{
            openPickerIcon: CalendarMonthIcon,
            openPickerButton: StyledButton,
            day: StyledDay,
          }}
          slotProps={{
            openPickerIcon: { fontSize: "medium", backgroundColor: "#c4960c" },
            openPickerButton: { color: "#c4960c" },
            textField: { variant: "outlined", color: "primary", size: "small", fullWidth: true, error: false },
            field: { clearable: true }
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
